
import { Options, Vue } from 'vue-class-component';
import pkg from '../../package.json';

@Options({
  props: {
    filter: String
  }
})
export default class PackageVersions extends Vue {
  versionFilter!: string;

  VERSION = pkg.version;

  get packages() {
   return pkg.dependencies;
  }

  cleanVersion(version: string) {
    return version.replace(/[^~]/,'');
  }

}

